$(function() {
  p_pathname = document.location.pathname;
  if (p_pathname.indexOf('/collections/') !== -1
      && p_pathname.indexOf('/products/') !== -1
      && p_pathname.indexOf('_') !== -1
      && p_pathname.indexOf('_') < p_pathname.indexOf('/products/')) {
    setTimeout(function() {
      let variant_start = p_pathname.indexOf('_', 13);
      if (variant_start !== -1) {
        let variant_name = p_pathname.substr(variant_start + 1, p_pathname.indexOf('/', 13) - variant_start - 1);
        $("ul.swatches-select").find("[data-value='" + variant_name + "']").click();
      }
    },1000);
  }
});